export const isValidatePostcode = (postcode: string): boolean => {
  if (postcode.trim().length === 0) {
    return false;
  }
  postcode = postcode.replace(/\s/g, "");
  const regex = /^[A-Z]{1,2}[0-9]{1,2} ?[0-9][A-Z]{2}$/i;
  return regex.test(postcode);
};


